import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  displayLimitedField,
} from "../../../utils/helpers";
import { trim } from "lodash/fp";

const OrderNoteCell = ({
  rowData,
  positionFromRight = "30",
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  let noteDisplay = "";
  if (!isEmptyVal(rowData.customer_order_note)) {
    noteDisplay += rowData.customer_order_note;
  }
  if (!isEmptyVal(rowData.remarks)) {
    noteDisplay += " " + rowData.remarks;
  }
  noteDisplay = trim(noteDisplay);
  const speaker = (
    <Popover title={t("ORDER") + " " + t("NOTE") + ":"}>
      <p>
        <p>
          <b>
            {t("CUSTOMER")} {t("NOTE")} :
          </b>{" "}
          <br />
          {displayField(rowData.customer_order_note)}
        </p>
      </p>
      <p>
        <p>
          <b>
            {t("ADDITIONAL")} {t("REMARKS")} :
          </b>{" "}
          <br />
          {displayField(rowData.remarks)}
        </p>
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayLimitedField(noteDisplay)}</a>
      </Whisper>
    </Cell>
  );
};

export default OrderNoteCell;
